import type { DeepKeys, DeepValue, RowData } from "@tanstack/vue-table";
import type {
	ComponentOptionsMixin,
	CreateComponentPublicInstanceWithMixins,
	EmitsOptions,
	EmitsToProps,
	PublicProps,
	ShortEmitsToObject,
	SlotsType,
} from "vue";
import type { FacetedOptions } from "../data-collection/composables/faceted-types";
import Column, { type ColumnProps, type ColumnSlots } from "./Column.vue";

type FunctionalProps<TProps, TEmit extends EmitsOptions = EmitsOptions> = TProps &
	EmitsToProps<TEmit> &
	PublicProps;

type SimpleComponentInstance<
	TProps,
	TEmits extends Record<string, any> = {},
	TSlots extends SlotsType<Record<string, any>> = {},
> = CreateComponentPublicInstanceWithMixins<
	TProps,
	{},
	{},
	{},
	{},
	ComponentOptionsMixin,
	ComponentOptionsMixin,
	ShortEmitsToObject<TEmits>,
	PublicProps,
	{},
	false,
	{},
	TSlots
>;

type ColumnComponent<TData extends RowData> = new <
	TKey extends DeepKeys<TData>,
	TValue extends DeepValue<TData, TKey>,
>(
	props: FunctionalProps<ColumnProps<TData, TKey, TValue>>
) => SimpleComponentInstance<
	ColumnProps<TData, TKey, TValue>,
	{},
	SlotsType<ColumnSlots<TData, TValue>>
>;

export function makeColumnHelper<TData extends RowData>() {
	return { Column: Column as unknown as ColumnComponent<TData> };
}

export function makeFacetedMapping<T>(mapping: FacetedOptions<T>): FacetedOptions<T> {
	return mapping;
}
